import Vue from 'vue'
import App from './App.vue'
import '../public/flexble'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import scroll from 'vue-seamless-scroll'
import Vant from 'vant'
import 'vant/lib/index.css'
import axios from 'axios'
import  HappyScroll  from 'vue-happy-scroll'
import 'vue-happy-scroll/docs/happy-scroll.css'
import VueLazyload from 'vue-lazyload'
import animate from "animate.css"
Vue.use(animate)

Vue.use(VueLazyload)
Vue.prototype.$axios = axios
Vue.use(HappyScroll)
Vue.use(Vant)
Vue.use(scroll)
Vue.config.productionTip = false
Vue.use(ElementUI)

router.afterEach( ( to, from, next ) => {

  setTimeout(()=>{
          var _hmt = _hmt || [];
          (function() {
              //每次执行前，先移除上次插入的代码
              document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
              var hm = document.createElement("script");
              hm.src = "https://hm.baidu.com/hm.js?7eee6f96ee6bcfa8fcca010f1011cf68";
              // hm.src = "https://hm.baidu.com/hm.js?7eee6f96ee6bcfa8fcca010f1011cf68";
              hm.id = "baidu_tj"
              var s = document.getElementsByTagName("script")[0];
              s.parentNode.insertBefore(hm, s);
          })();
  },0);

} );


new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app')
